import { useFormContext } from "react-hook-form";
import InputField from "@medoma/components/InputField/InputField";
import Form from "@/components/Form/Form";
import { useLingui } from "@lingui/react/macro";

export type PatientNameInputFields = {
  givenName: string;
  familyName: string;
};

const PatientNameInput = ({ readonly }: { readonly?: boolean }) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<PatientNameInputFields>();

  // A name that is only shown cannot be corrected here, so requiring one would leave the
  // form with an error nobody can clear.
  const description = readonly
    ? t`Går att ändra under patientinformation`
    : undefined;

  return (
    <Form.Row>
      <InputField
        readOnly={readonly}
        type="text"
        {...register("givenName", {
          required: {
            value: !readonly,
            message: t`Ange förnamn`,
          },
        })}
        label={t`Förnamn`}
        showOptionalLabel={false}
        description={description}
        errorMessage={errors.givenName?.message}
      />
      <InputField
        readOnly={readonly}
        type="text"
        {...register("familyName", {
          required: {
            value: !readonly,
            message: t`Ange efternamn`,
          },
        })}
        label={t`Efternamn`}
        showOptionalLabel={false}
        description={description}
        errorMessage={errors.familyName?.message}
      />
    </Form.Row>
  );
};

export default PatientNameInput;
